import { useMemo } from 'react';
import { use_slice_user, use_slice_workspace, use_slice_workspace_billing } from './store/use_slices';

export function use_workspace_balance() {
  const { balances_map } = use_slice_workspace_billing(['balances_map']);
  const { current_workspace_user, is_all_data_loaded } = use_slice_workspace(['current_workspace_user', 'is_all_data_loaded']);
  const { is_authorized } = use_slice_user(['is_authorized']);

  const out = useMemo(() => {
    if (!is_all_data_loaded) return NaN;
    if (current_workspace_user.is_stub()) return NaN;
    if (!is_authorized) return NaN;

    let workspace_balance_dto = balances_map.get_or_assert(current_workspace_user.workspace_id, { context: 'balance' });

    let out = workspace_balance_dto.credits;

    if (current_workspace_user.credits_limit_enabled) {
      let credits_per_month_left = current_workspace_user.credits_limit - current_workspace_user.credits_per_month_used;

      out = Math.min(out, credits_per_month_left);

      out = Math.max(out, 0); //could be negative when limit is less than user already spent per month
    }

    return out;
  }, [
    balances_map,
    current_workspace_user.credits_limit_enabled,
    current_workspace_user.credits_limit,
    current_workspace_user.credits_per_month_used,
    is_all_data_loaded,
  ]);

  return out;
}
